var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [{ name: "track", rawName: "v-track:100", arg: "100" }],
      staticClass: "mainWrapper"
    },
    [
      _c(
        "el-aside",
        { staticStyle: { padding: "0" }, attrs: { width: "0vw" } },
        [
          _c("drawer-aside", {
            attrs: { unfold: _vm.unfold },
            on: {
              unfoldMethod: function($event) {
                return _vm.fold($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("header-section", { on: { spread: _vm.spread } }),
          _vm._v(" "),
          _c(
            "el-main",
            { staticStyle: { padding: "0", overflow: "visible" } },
            [
              _vm.isLoading
                ? _c("div", { staticClass: "loading-overlay" }, [
                    _c("div", {
                      staticClass: "loading-spinner",
                      staticStyle: {
                        display: "flex",
                        color: "#003333",
                        "justify-content": "center",
                        "align-items": "center"
                      }
                    })
                  ])
                : _c(
                    "div",
                    [
                      _c("listing-details-tabs", {
                        attrs: {
                          listFloorPlan: _vm.listFloorPlan,
                          "props-image": this.item,
                          currentRoom: this.item
                        },
                        on: { updateRow: _vm.updateRow }
                      }),
                      _vm._v(" "),
                      _c("listing-details", {
                        attrs: {
                          currentRoom: _vm.currentRoom,
                          "listing-details": this.item
                        }
                      }),
                      _vm._v(" "),
                      _c("meet-agent", { attrs: { "props-data": this.item } }),
                      _vm._v(" "),
                      _c("listing-location", {
                        attrs: { "listing-details": this.item }
                      })
                    ],
                    1
                  )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticStyle: { padding: "0", height: "0" } },
            [_c("footer-section")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07cce34a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07cce34a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/propertyDetails/detailsLayout.vue
// module id = null
// module chunks = 